import { IApplicationState } from '../../types/redux';

export function selectPuids(state: IApplicationState) {
  if (state.developer) {
    return state.developer.puids;
  }

  if (state.developerV2.templateSpecialPromo) {
    return state.developerV2.templateSpecialPromo.puids;
  }

  return null;
}
